import { loanApi } from '@/apis/spot';

export function useLoopResult({ type, url, params }) {
    return new Promise((resolve) => {
        let num = 0;
        let timer = null;
        let finalResult = {
            status: 'I',
        };

        const loopResult = async () => {
            if (num >= 5) {
                num = 0;
                clearTimeout(timer);
                finalResult.status = 'P';
                resolve(finalResult);
                return;
            }
            num += 1;
            const res = await loanApi[url](params);
            if (!res || !res.success || !res.result) {
                timer = setTimeout(loopResult, 2000);
                return;
            }

            const target = type === 'loan' ? res.result.loanOrderList : res.result;
            if (!target.length) {
                timer = setTimeout(loopResult, 2000);
                return;
            }
            // 这里结果为第一条数据
            const [value] = target;
            const { status } = value;
            if (status === 'S' || status === 'F') {
                clearTimeout(timer);
                num = 0;
                finalResult = {
                    ...value,
                };
                resolve(finalResult);
                return;
            }
            timer = setTimeout(loopResult, 2000);
        };

        loopResult();
    });
}
